const enum PermissionStatus {
  All = 'All',
  Restricted = 'Restricted',
  None = 'None',
}

export default PermissionStatus;
